import { connect } from 'react-redux';
import { v4 } from 'uuid';

import * as BulkUpdateActions from '../../../../store/bulk/update/bulk.update.actions';

import { Scale } from '../../../../fulfillment-planner/weight/scale';

const mapDispatchToProps = (dispatch, { jobId }) => {
  return {
    onReadFromScale: (scale) => {
      dispatch(BulkUpdateActions.bulkUpdateReadFromScale(scale, jobId ?? v4()));
    },
  };
};

export const ScaleContainer = connect(null, mapDispatchToProps)(Scale);
